import {ComponentConfigDefault} from "models/dataset-models";
import {CSSProperties} from "react";

export interface IDatasetTableCommonProps {
    data: Array<any>
    config?: ComponentConfigDefault
    datasetsArray: Array<any>
    totals: IDatasetTotal[]
    setIsDialogOpen: (value: boolean) => void
}

export interface IDatasetTableDefaultProps extends IDatasetTableCommonProps {
    getCellStyle: (date: string, obj: any) => CSSProperties | undefined
}

export interface IDataArray {
    [key: string]: string | number;
}

export interface IDatasetTotal {
    identifier: string;
    value?: string;
    tooltip?: string;
}

export enum DatasetTableMode {
    SINGLE = "SINGLE",
    GROUPED = "GROUPED"
}

export interface IFlattenedDataset {
    title: string,
    identifier: string,
    unit: string,
    decimalPlaces: string
}